import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { ElementTemplate } from '../../../Library/P.O.Template/TemplateComponent';
import { usePOTemplateOrderState } from '../AddPOTemplateProvider';

function SupplierDetails({ col, i, index, onChange, eleIndex, changePosition, supplierData, fromForm }) {
  const { duplicatingItem, deleteItem, dropLocation, dropInLocation, editingInput } = usePOTemplateOrderState();
  const companyRef = useRef(null);
  const { t } = useTranslation('common');
  const ifNotContainer = (i, index, item) => {
    return item?.col ? changePosition(item, index, i) : dropInLocation(i, index, item, supplierData.id);
  };
  const [{ item, handlerId, isOver }, drop] = useDrop({
    accept: ['container', 'item'],
    drop: () => {
      item?.type === 'container' ? dropLocation(index, item) : ifNotContainer(i, index, item);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      handlerId: monitor.getHandlerId(),
      isOver: monitor.isOver(),
    }),
  });

  const [{ isDragging }, drag] = useDrag({
    type: col?.type,
    item: () => {
      return { col, index, i };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(companyRef));

  return (
    <div ref={companyRef} style={{ opacity }} data-handler-id={handlerId} key={`${col?.label}_${index}_${i}`}>
      {isOver && <div className="potemplate-drag-placeholder">{t('COMPANY_DETAILS.DROP_SECTION')}</div>}
      <ElementTemplate
        {...col}
        keys={col?.key}
        error={col?.hasError}
        requiredField={col?.required}
        // disable={!fromForm || ["0", "3"].includes(col.uniqueId)}
        options={col?.options}
        placeHolder={col?.placeholder ? `${col?.placeholder}` : `${col?.label}`}
        fromForm={fromForm}
        duplicatingItem={duplicatingItem}
        editingInput={editingInput}
        index={index}
        i={i}
        id={col?.id}
        value={col?.value}
        onChange={onChange}
        elekey={supplierData?.key}
        eleIndex={eleIndex}
        deleteItem={deleteItem}
        showDelete
      />
    </div>
  );
}

export default SupplierDetails;
